import { useDispatch } from 'react-redux'
import { UseMutationOptions, useMutation } from '@cbgms/base/http/use-query'
import { uploadImage } from '../state/actions'
import { POSTThemeLogo } from '@cbgms/api'

export const useMutateThemeLogo = (options?: UseMutationOptions<POSTThemeLogo, unknown, File, unknown> | undefined) => {
  const dispatch = useDispatch()

  return useMutation(async image => {
    return dispatch(uploadImage(image))
  }, options)
}
